import { Injectable } from '@angular/core';
import { Loader } from '../classes/loader';

/**
 * Service to provide a global loader instance
 */
@Injectable({
	providedIn: 'root'
})
export class LoaderService {
	private readonly _loader: Loader;
	private readonly _externalLoader: Loader;

	constructor() {
		// create global loader instance
		this._loader = new Loader();
		this._externalLoader = new Loader();
	}

	/**
	 * Get global loader instance
	 *
	 * @returns
	 */
	public get loader(): Loader {
		return this._loader;
	}

	/**
	 * Get global loader instance for External Session Login
	 *
	 * @returns
	 */
	public get externalLoader(): Loader {
		return this._externalLoader;
	}
}
